exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".standard[data-v-7c6b6304]{max-width:550px!important}.large[data-v-7c6b6304]{max-width:900px!important}.small[data-v-7c6b6304]{max-width:300px!important}.modal-dialog[data-v-7c6b6304]{max-height:100vh}", ""]);

// exports
